import { Component, output, input, signal, OnDestroy, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomInputComponent } from '../../inputs/custom-input/custom-input.component';
import { CustomButtonComponent } from '../../inputs/custom-button/custom-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { Actions, ofType } from '@ngrx/effects';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { passwordResetSuccess, passwordResetFailure } from '../../../store/auth/auth.actions';
import { CustomFormValidators } from '../../../helperts/custom-form-validators.helper';
@Component({
  selector: 'lib-forgot-password',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    CustomInputComponent,
    CustomButtonComponent,
    TranslateModule,
  ],
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent implements OnDestroy {
  signInLink = input<string>('/login'); // Or your default sign-in path
  featureImageUrl = input<string | null>('public/shared/images/background-login.jpg');
  /** Tailwind color class for image column background */
  imageContainerBgTone = input<string>('bg-blue-950');
  forgotPasswordSubmit = output<{ email: string }>();
  forgotPasswordForm: FormGroup;
  messageSent = signal<boolean>(false);
  loading = signal<boolean>(false);
  private _router = inject(Router);

  private _destroy$ = new Subject<void>();

  constructor(
    private _fb: FormBuilder,
    private _actions$: Actions
  ) {
    this.forgotPasswordForm = this._fb.group({
      email: ['', [Validators.required, CustomFormValidators.emailWithTld()]],
    });

    // Turn off loading when password reset succeeds or fails
    this._actions$
      .pipe(ofType(passwordResetSuccess, passwordResetFailure), takeUntil(this._destroy$))
      .subscribe((action) => {
        this.loading.set(false);
        if (action.type === passwordResetSuccess.type) {
          this.messageSent.set(true);
        }
      });
  }

  // No se requiere ngOnInit por ahora

  onSubmit(): void {
    if (this.forgotPasswordForm.valid && !this.loading()) {
      this.loading.set(true);
      this.forgotPasswordSubmit.emit({ email: this.forgotPasswordForm.value.email });
    } else {
      this.forgotPasswordForm.markAllAsTouched();
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  goToLogin(): void {
    this._router.navigate(['/login']);
  }
}
